import React, { useState } from 'react';
import OTPSuccessDialog from './OTPSuccessDialog';

function useConfirmationDialogV2 (props) {
    const {
        onClose = () => {},
        onConfirm = () => {},
        open: defaultOpen = false,
        title: defaultTitle,
        message: defaultMessage,
        confirmLabel = 'Ok',
        cancelLabel = '',
        showSecondaryButton = false,
        showPrimaryButton = true,
    } = props;

    const [open, setOpen] = useState(defaultOpen);
    const [title, setTitle] = useState(defaultTitle);
    const [message, setMessage] = useState(defaultMessage);

    function renderDialog () {
        if (!open) {
            return null;
        }
        return (
            <OTPSuccessDialog
                open={open}
                showSecondaryButton={showSecondaryButton}
                showPrimaryButton={showPrimaryButton}
                cancelLabel={cancelLabel}
                confirmLabel={confirmLabel}

                onConfirm={() => {
                    if (typeof onConfirm === 'function') {
                        onConfirm();
                        setOpen(false);
                    }
                }}

                onClose={() => {
                    if (typeof onClose === 'function') {
                        onClose();
                        setOpen(false);
                    }
                }}
                title={title}
                message={message}
            />
        );
    }

    function openDialog (newTitle = null, newMessage = null) {
        if (newTitle) {
            setTitle(newTitle);
        }

        if (newMessage) {
            setMessage(newMessage);
        }
        setOpen(true);
    };

    return {
        renderDialog,
        openDialog,
    };
}

export default useConfirmationDialogV2;
